/**
 * listing redux reducer
 * 
 * @author    Jens Gruschel
 * @copyright © 2018 contexagon GmbH
 */


import {
    FETCH_OBJECT_QUERY, UPDATE_SEARCH_INPUT,
    DELETE_OBJECT, UNDELETE_OBJECT
} from './consts';
import {LOGOUT} from "../authorization/consts"; // TODO: how to handle global actions?


const initialState = {
    objectList: [], // list of all objects when applying a filter or executing a search
    objectAccessLevels: {},
    objectRefCounts: {},
    searchInput: "",
    subFilters: {}
};


export default function listingReducer(state = initialState, action) {

    switch (action.type) {

        case UPDATE_SEARCH_INPUT: {
            return {
                ...state,
                searchInput: action.text
            };
        }

        case FETCH_OBJECT_QUERY: {

            return {
                ...state,
                objectList: action.objectList,
                objectAccessLevels: action.objectAccessLevels,
                objectRefCounts: action.objectRefCounts
            };
        }

        case DELETE_OBJECT: {

            return {
                ...state,
                objectList: state.objectList.filter(object => object.id !== action.id)
            };
        }

        case UNDELETE_OBJECT: {

            // remove object from list of objects in trash (which hopefully is the current object list)
            return {
                ...state,
                objectList: state.objectList.filter(object => object.id !== action.id)
            };
        }

        case LOGOUT:

            return initialState;

        default:
            return state;
    }
}
